var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"transaction-chart card"},[_c('ApexChart',{staticClass:"transaction-chart__chart",attrs:{"width":"100%","height":"260","type":"area","options":_vm.options,"series":_vm.series}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }